import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

const SOCIAL = [
  { key: 'instagram', icon: 'fab fa-instagram',  label: 'Instagram' },
  { key: 'facebook',  icon: 'fab fa-facebook-f', label: 'Facebook'  },
  { key: 'whatsapp',  icon: 'fab fa-whatsapp',   label: 'WhatsApp'  },
  { key: 'youtube',   icon: 'fab fa-youtube',    label: 'YouTube'   },
];

export default function Footer() {
  const [config, setConfig] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get('/footer-config')
      .then(res => {
        const data = res?.data.data || res || {};
        const mappedConfig = {
          tagline: data.tagline,
          phone: data.phone,
          email: data.email,
          copyrightText:data.copyrightText || `© ${new Date().getFullYear()} Pandian Store. All rights reserved.`,
          socialMedia: data.socialMedia || {}
        };
        setConfig(mappedConfig);
      })
      .catch(err => {
        console.error('Failed to fetch store settings:', err);
        setConfig({});
      });
  }, []);

  useEffect(() => {
    api.get('/products/categories')
      .then(res => setCategories(Array.isArray(res.data) ? res.data : res.data.categories || []))
      .catch(() => setCategories([]));
  }, []);

  if (!config) return null;

  const { tagline, phone, email, copyrightText, socialMedia = {} } = config;
  const waHref = socialMedia.whatsapp;

  return (
    <>
    <footer className="site-footer">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-4">
            <div className="footer-logo">
              <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="PandianStore" />
            </div>
            {tagline && <p className='footerDesc'>{tagline}</p>}
            <div className="socialMediaicon">
              {SOCIAL.filter(({ key }) => socialMedia[key]).map(({ key, icon, label }) => (
                <a
                  key={key}
                  href={socialMedia[key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="footer-social-btn"
                >
                  <i className={icon} />
                </a>
              ))}
            </div>
          </div>

          <div className="col-6 col-lg-2">
            <p className="footer-heading">Shop</p>
            <ul className="footer-links">
              {categories.map(cat => (
                <li key={cat.id}>
                  <Link to={`/shop`}>{cat.name}</Link>
                </li>
              ))}
              <li><Link to="/trending">Trending</Link></li>
              <li><Link to="/catalogue">Catalogue</Link></li>
            </ul>
          </div>

          <div className="col-6 col-lg-2">
            <p className="footer-heading">Account</p>
            <ul className="footer-links">
              <li><Link to="/dashboard">My Account</Link></li>
              <li><Link to="/dashboard">My Orders</Link></li>
              <li><Link to="/cart">Cart</Link></li>
              <li><Link to="/wishlist">Wishlist</Link></li>
              <li><Link to="/refund-policy">Returns</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="col-lg-4">
            <p className="footer-heading">Contact Us</p>
            <div className='footerContact'>
              <div className='footerContact-add'>
                <i className="fas fa-map-marker-alt" />
                <span className='footerContact-add-text'>Tamil Nadu, India</span>
              </div>
              {phone && (
                <div className='footerContact-add'>
                  <i className="fas fa-phone" />
                  <a href={`tel:${phone}`} className='footerContact-add-text'>{phone}</a>
                </div>
              )}
              {email && (
                <div className='footerContact-add'>
                  <i className="fas fa-envelope" />
                  <a href={`mailto:${email}`} className='footerContact-add-text'>{email}</a>
                </div>
              )}
              <div className='footerContact-add'>
                <i className="fas fa-clock" />
                <span className='footerContact-add-text'>Mon–Sat: 9am–9pm</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>{copyrightText}</p>
          <div className="footer-bottom-links">
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/refund-policy">Refunds</Link>
          </div>
        </div>
      </div>
    </footer>
    {waHref && (
    <section className="leftWhatsapp">
      <a href={waHref} target="_blank" rel="noopener noreferrer">
        <img src={process.env.PUBLIC_URL + "/images/whatsapp-icon.svg"} className="img-fluid" alt="WhatsApp - Pandian Store" />
      </a>
    </section>
    )}
    </>
  );
}